export enum AppType {
  portal = 'portal',
  management = 'management',
  myMonitoring = 'myMonitoring'
}
